import Lib from "../Lib";

/**
 * @param {HTMLElement} element
 * @return {boolean}
 */
const elementIsVisible = function (element) {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
};

/**
 * @param {*[]|NodeList} collection
 * @param {function} callback
 * @return {*}
 */
const map = Lib.map;

/**
 * Toggle deeper levels of the mobile navigation
 */
export default class MobileNavigationToggle {
    /**
     * @param {HTMLElement} navigation Navigation element
     */
    constructor(navigation) {
        const _click = this.click = this.click.bind(this);
        this._navigation = navigation;

        map(navigation.querySelectorAll('li,.li,.nav-menu-item'), function (element) {
            element.addEventListener('click', _click);
        });
    }

    /**
     * @param {MouseEvent} event
     */
    click(event) {
        /** @type {HTMLElement|EventTarget} */
        const clickedElement = event.target;
        /** @type {HTMLElement|EventTarget} */
        const listeningElement = event.currentTarget;

        /*
         * If the clicked element is not a link (or child of a link) and the navbar-toggle button is visible
         * toggle the class and stop to event from bubbling up
         */
        if (this._isCollapsed() && !this._isLinkChild(clickedElement, this._navigation)) {
            this._toggleClass(listeningElement, 'on');
            event.preventDefault();
            event.stopPropagation();
        }
    }

    _isCollapsed() {
        const navbarToggle = document.querySelector('.navbar-toggle');
        if (navbarToggle) {
            return elementIsVisible(navbarToggle);
        }

        return window.matchMedia && window.matchMedia("only screen and (max-width: 767px)").matches;
    }

    /**
     * @param {HTMLElement} element
     * @param {string} className
     * @private
     */
    _toggleClass(element, className) {
        const classList = element.classList;
        if (classList.contains(className)) {
            classList.remove(className);
        } else {
            classList.add(className);
        }
    }

    /**
     * @param {Node|HTMLElement} element
     * @return {boolean}
     * @private
     */
    _isLink(element) {
        return ['A', 'BUTTON', 'INPUT'].indexOf(element.tagName) !== -1
            || (element.getAttribute && element.getAttribute('href'));
    }

    /**
     * @param {Node} element
     * @param {Node} [stop]
     * @return {boolean}
     * @private
     */
    _isLinkChild(element, stop) {
        if (this._isLink(element)) {
            return true;
        }

        const parent = element.parentNode;
        if (!parent || parent === document || (stop && parent === stop)) {
            return false;
        }

        return this._isLinkChild(parent, stop);
    }
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/Ui/MobileNavigationToggle.js